"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimeSnapshotError = exports.RUNTIME_SNAPSHOT_SCHEMA_VERSION = void 0;
exports.assertRuntimeSnapshot = assertRuntimeSnapshot;
exports.gameSessionFromSnapshot = gameSessionFromSnapshot;
exports.sessionDataFromGameSession = sessionDataFromGameSession;
const GameSession_1 = require("../models/GameSession");
exports.RUNTIME_SNAPSHOT_SCHEMA_VERSION = 1;
class RuntimeSnapshotError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RuntimeSnapshotError';
    }
}
exports.RuntimeSnapshotError = RuntimeSnapshotError;
function assertRuntimeSnapshot(value, expectedAdventureId) {
    if (!value || typeof value !== 'object') {
        throw new RuntimeSnapshotError('Snapshot must be a JSON object');
    }
    const snapshot = value;
    if (snapshot.schemaVersion !== exports.RUNTIME_SNAPSHOT_SCHEMA_VERSION) {
        throw new RuntimeSnapshotError(`Unsupported snapshot schemaVersion: ${String(snapshot.schemaVersion)} (expected ${exports.RUNTIME_SNAPSHOT_SCHEMA_VERSION})`);
    }
    if (!snapshot.adventureId || typeof snapshot.adventureId !== 'string') {
        throw new RuntimeSnapshotError('Snapshot missing adventureId');
    }
    if (expectedAdventureId && snapshot.adventureId !== expectedAdventureId) {
        throw new RuntimeSnapshotError(`Snapshot adventureId '${snapshot.adventureId}' does not match '${expectedAdventureId}'`);
    }
    if (!snapshot.session || typeof snapshot.session !== 'object') {
        throw new RuntimeSnapshotError('Snapshot missing session');
    }
    if (!Array.isArray(snapshot.session.players)) {
        throw new RuntimeSnapshotError('Snapshot session.players must be an array');
    }
    if (!snapshot.variables || typeof snapshot.variables !== 'object') {
        throw new RuntimeSnapshotError('Snapshot missing variables');
    }
    const scopes = snapshot.variables;
    for (const key of ['user', 'adventure', 'player', 'character', 'scene']) {
        if (!scopes[key] || typeof scopes[key] !== 'object') {
            throw new RuntimeSnapshotError(`Snapshot variables.${key} must be an object`);
        }
    }
    return snapshot;
}
function gameSessionFromSnapshot(snapshot) {
    return new GameSession_1.GameSession({
        id: snapshot.session.id,
        adventureId: snapshot.adventureId,
        players: snapshot.session.players,
        locationInventories: new Map(Object.entries(snapshot.session.locationInventories ?? {})),
        status: snapshot.session.status,
        createdAt: new Date(snapshot.session.createdAt),
        updatedAt: new Date(snapshot.session.updatedAt),
        createdByUserId: snapshot.session.createdByUserId,
        isGuest: snapshot.session.isGuest,
    });
}
function sessionDataFromGameSession(session) {
    const json = session.toJSON();
    const locationInventories = {};
    for (const [tag, items] of json.locationInventories.entries()) {
        locationInventories[tag] = [...items];
    }
    return {
        id: json.id,
        status: json.status,
        createdAt: json.createdAt.toISOString(),
        updatedAt: json.updatedAt.toISOString(),
        createdByUserId: json.createdByUserId,
        isGuest: json.isGuest,
        players: json.players,
        locationInventories,
    };
}
//# sourceMappingURL=RuntimeSnapshot.js.map